import { Auth } from '@/type';
import { CredentialsProvider, Credentials } from './types';
import oauth2Provider from './oauth2-provider';
import loginProvider from './login-provider';

class DelegatingCredentialsProvider {
  private providers: CredentialsProvider[] = []

  public add(provider: CredentialsProvider): void {
    this.providers.push(provider);
  }

  public getCredentials(
    platform: string,
    auth: Auth,
    permissions: string[] = [],
  ): Promise<Credentials|null> {
    for (let i = 0; i < this.providers.length; i += 1) {
      if (this.providers[i].supports(platform, auth)) {
        return this.providers[i].getCredentials(platform, auth, permissions);
      }
    }
    throw new Error(`No credentials provider found for ${platform}`);
  }
}

const provider = new DelegatingCredentialsProvider();
provider.add(oauth2Provider);
provider.add(loginProvider);

export default provider;
